import { useLang } from "../i18n/LangContext";
import { PROGRAM } from "../data/programData";

export const ProgramPage = () => {
  const { lang } = useLang();
  const p = PROGRAM[lang];
  return (
    <main data-testid="program-main" className="min-h-[70vh] bg-surface/50">
      <div className="mx-auto max-w-4xl px-6 pb-14 pt-10">
        <p className="eyebrow">{p.eyebrow}</p>
        <h1 data-testid="program-title" className="mt-2 font-serif text-3xl font-semibold tracking-tight text-ink md:text-5xl">
          {p.pageTitle}
        </h1>

        <a
          href="https://novuscodex.gr"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="program-sponsor"
          className="mt-8 flex flex-col items-center gap-3 text-center"
        >
          <img src="/images/novus-codex-logo.png" alt="NOVUS CODEX" className="h-16 w-auto md:h-20" />
          <span className="text-sm font-semibold leading-relaxed text-ink">{p.sponsorNote}</span>
        </a>

        <div className="mt-10 space-y-6">
          {p.introParagraphs.map((par, i) => (
            <p key={i} data-testid={`program-intro-${i}`} className="text-base leading-relaxed text-muted-foreground md:text-lg">{par}</p>
          ))}
        </div>
      </div>
    </main>
  );
};
